module.exports = __webpack_public_path__ + "img/Daniel_M.6b4455ad.jpg";